export * from './components/Modal/index';
export { Modal as default } from './components/Modal/index';
